import { Spacing } from '@persona-id/design-tokens';
import { PropsWithChildren } from 'react';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom-v5-compat';
import { formValueSelector } from 'redux-form';
import styled from 'styled-components';

import { INQUIRY_TEMPLATE_EDITOR_FORM_NAME } from 'dashboard/apps/InquiryTemplateEditor/InquiryTemplateEditor/constants';
import { RootState } from 'dashboard/redux/store';
import { Label } from 'design-system/components/Text';
import { FieldSchema } from 'lib/fields';
import { getOnlyLastPath } from 'lib/utils/url';

const form = INQUIRY_TEMPLATE_EDITOR_FORM_NAME;
const selector = formValueSelector(form);

const DefaultCountryRow = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-top: ${Spacing[3]};
`;

const DefaultCountryText = styled(Label).attrs(() => ({ size: 'md', weight: 'bold' }))`
  font-weight: ${({ theme }) => theme.text.paragraph.md.fontWeight};
`;

const EditLink = styled(Link)`
  margin-left: 6px;
`;

interface InputCountrySelectComponentConfigAddOnProps {
  fieldPath: string;
  editable: boolean;
}

const InputCountrySelectComponentConfigAddOn = ({
  fieldPath,
  editable,
  children,
}: PropsWithChildren<InputCountrySelectComponentConfigAddOnProps>) => {
  const fieldSchema = useSelector<RootState, FieldSchema[]>(
    (state) => selector(state, 'field-schema') ?? [],
  );

  const defaultCountry = fieldSchema.find((field) => field.key === getOnlyLastPath(fieldPath))?.[
    'default-value'
  ];

  return (
    <>
      {children}
      <DefaultCountryRow>
        <DefaultCountryText>
          {`Default: ${defaultCountry ?? 'None'}`}
          {editable && <EditLink to={fieldPath}>Update</EditLink>}
        </DefaultCountryText>
      </DefaultCountryRow>
    </>
  );
};

export default InputCountrySelectComponentConfigAddOn;
